import { render } from "./ConvoBox.vue?vue&type=template&id=5e9b1d85&scoped=true"
import script from "./ConvoBox.vue?vue&type=script&lang=js"
export * from "./ConvoBox.vue?vue&type=script&lang=js"

import "./ConvoBox.vue?vue&type=style&index=0&id=5e9b1d85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9b1d85"]])

export default __exports__